module.exports = __webpack_public_path__ + "img/gp2.d92ae178.png";